<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card tm-mb-info-card">
    <v-row class="com-mb-card-contents" no-gutters>
      <v-expansion-panels accordion class="tm-mb-obs-panel">
        <v-expansion-panel>
          <v-expansion-panel-header
            class="tm-mb-obs-panel-header"
            expand-icon="arrow_drop_down"
          >
            <v-row no-gutters>
              <v-row class="tm-mb-obs-panel-content" no-gutters>
                <div class="tm-mb-obs-panel-item">
                  <span class="tm-mb-rvrnm">
                    {{ tmSwStageMtObs.swobsNm }}
                  </span>
                </div>
                <div class="tm-mb-obs-panel-item">
                  <span class="tm-mb-rvrnm">
                    {{ tmSwStageMtObs.swrsysNm }}{{ text.rsys }}
                  </span>
                </div>
                <div class="tm-mb-obs-panel-item">
                  <span class="tm-mb-rvrnm">
                    {{ tmSwStageMtObs.swrvrNm }}
                  </span>
                </div>
              </v-row>
              <v-row no-gutters class="tm-mb-curt-time">
                {{ text.obsTime }} {{ obsTime }}
              </v-row>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="tm-mb-obs-content">
            <v-list dense class="tm-mb-obs-content-v-list">
              <!-- 観測所情報 -->
              <v-list-item
                v-for="(item, index) in tmSwobsInfo"
                :key="`obs-${index}`"
                class="tm-mb-obs-content-v-list-item"
                v-show="!item.notMb"
              >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  >{{ item.title }}</v-list-item-content
                >
                <v-list-item-content
                  v-if="item.itmkndCd"
                  class="tm-mb-link tm-mb-obs-content-v-list-item-content"
                  @click="clickObsList(item.ofcCd, item.itmkndCd, item.obsCd)"
                  >{{ item.value }}</v-list-item-content
                >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  v-else
                >
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- 基準値 -->
              <v-list-item
                v-for="(item, index) in standardValue"
                :key="`sd-${index}`"
                class="tm-mb-obs-content-v-list-item"
              >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  >{{ item.title }}</v-list-item-content
                >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                >
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- コード -->
              <v-list-item
                v-for="(item, index) in codeInfo"
                :key="`sd-${index}`"
                class="tm-mb-obs-content-v-list-item"
              >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  >{{ item.title }}</v-list-item-content
                >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                >
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]危機管理 観測所情報カード
 * TmSwStageInfo.vue
 * @author ILUKE
 */
import mixin from "./../../lib/mixin.js";

export default {
  name: "tm-sw-stage-info",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        obsTime: "最新観測値",
        obsInfo: "観測所情報",
        obsType: "水位計",
        rsys: "水系",
      },
    };
  },
  mounted() {},
  created() {
    this.$store.dispatch("map/getObsInformation", {
      ofcCd: this.$store.state.Swin.selectedSwParam.ofcCd,
      itmkndCd: this.$store.state.Swin.selectedSwParam.itmkndCd,
      obsCd: this.$store.state.Swin.selectedSwParam.obsCd,
    });
  },
  computed: {
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return this.$store.state.Swin.selectedSwParam;
      },
    },
    /**
     * 危機管理マスタ情報 取得
     */
    tmSwStageMtObs: {
      get() {
        return this.$store.state.Swin.selectedSw.mtSwobs.obsInfo;
      },
    },
    /**
     * 危機管理観測所情報 取得
     */
    tmSwobsInfo: {
      get() {
        return this.$store.state.Swin.selectedSw.obsInfo;
      },
    },
    /**
     * 基準値 取得
     */
    standardValue: {
      get() {
        return this.$store.state.Swin.selectedSw.standardValue;
      },
    },
    /**
     * お知らせ情報の中で緊急度が一番高い１レコードのみ取得
     */
    tmInfo: {
      get() {
        return this.$store.state.map.tmInfo;
      },
    },

    /**
     * コード値 取得
     */
    codeInfo: {
      get() {
        return this.$store.state.Swin.selectedSw.codeValue;
      },
    },
    /**
     * 観測時間 取得
     */
    obsTime: {
      get() {
        return this.$store.state.Swin.selectedSw.curt.obsTime;
      },
    },
  },
  methods: {
    /** 観測所リンク */
    clickObsList(ofcCd, itmkndCd, obsCd) {
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: ofcCd,
        itmkndCd: itmkndCd,
        obsCd: obsCd,
      });
      // 画面遷移
      this.routerPushTm("/pc/tm");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
